import React, { useState, useRef, useEffect } from "react";

const ImageSelect = ({
  id,
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Selected item object
  const selectedOption = options.find(
    (opt) => String(opt.value) === String(value)
  );

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div
      ref={containerRef}
      className={`image-select-container ${isOpen ? "open" : ""}`}
      id={id}
    >
      <div
        className={`image-select-trigger ${isOpen ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        tabIndex={disabled ? -1 : 0}
        role="combobox"
        aria-expanded={isOpen}
        aria-controls={`${id || "image-select"}-listbox`}
        aria-haspopup="listbox"
      >
        <div className="image-select-content">
          {selectedOption?.image && (
            <img
              src={selectedOption.image}
              alt={selectedOption.label || "option"}
              className="image-select-img"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <span className="image-select-text">
            {selectedOption ? selectedOption.label : placeholder}
          </span>
        </div>
        <i
          className={`bi bi-chevron-down image-select-arrow ${
            isOpen ? "rotate" : ""
          }`}
        ></i>
      </div>

      {isOpen && (
        <div className="image-select-dropdown" id={`${id || "image-select"}-listbox`} role="listbox">
          {options.length === 0 ? (
            <div className="image-select-option empty">No options available</div>
          ) : (
            options.map((opt) => {
              const isSelected = String(opt.value) === String(value);
              return (
                <div
                  key={opt.value}
                  className={`image-select-option ${
                    isSelected ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(opt.value)}
                  role="option"
                  aria-selected={isSelected}
                >
                  {opt.image && (
                    <img
                      src={opt.image}
                      alt={opt.label || "option"}
                      className="image-select-img"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  )}
                  <span className="image-select-text">{opt.label}</span>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default ImageSelect;
